<template>
    <div class="d-flex align-start h-100 tags" :class="{'pt-3 pl-3 position-absolute': floating, 'flex-column': column}" v-if="canShow">
        <v-chip
            v-for="(item, index) in flags" :key="index"
            density="compact"
            class="tag text-center py-3 font-italic text-uppercase"
            :style="{backgroundColor: item.color || red, color: item.color_text || 'white'}"
            label
        >
            {{item.name}}
        </v-chip>
    </div>
</template>
<script setup>

import {computed} from "vue";

const props = defineProps({
    flags: Object,
    floating: {
        type: Boolean,
        default: true
    },
    column: {
        type: Boolean,
        default: true
    }
});
const canShow = computed(() => props.flags && Object.keys(props.flags).length)
</script>
<style scoped lang="scss">
.tags{
    z-index: 999;
    left: 0;
    top: 0;
    gap: .3em;
}
.tag {
    border-radius: 8px 0 8px 0;
    background: red;
    color: white;
}
</style>
